/**
 * Determines the primary source of variants before falling back.
 *
 * @category Source
 */
export let Source;
/**
 * Indicates from which source the variant() function determines the variant
 *
 * @category Source
 */

(function (Source) {
  Source["LocalStorage"] = "localStorage";
  Source["InitialVariants"] = "initialVariants";
})(Source || (Source = {}));

export let VariantSource;
/**
 * Returns true if the VariantSource is one of the fallbacks (inline or config)
 *
 * @param source a {@link VariantSource}
 * @returns true if source is {@link VariantSource.FallbackInline} or {@link VariantSource.FallbackConfig}
 */

(function (VariantSource) {
  VariantSource["LocalStorage"] = "storage";
  VariantSource["InitialVariants"] = "initial";
  VariantSource["SecondaryLocalStorage"] = "secondary-storage";
  VariantSource["SecondaryInitialVariants"] = "secondary-initial";
  VariantSource["FallbackInline"] = "fallback-inline";
  VariantSource["FallbackConfig"] = "fallback-config";
  VariantSource["LocalEvaluation"] = "local-evaluation";
})(VariantSource || (VariantSource = {}));

export const isFallback = source => {
  return !source || source === VariantSource.FallbackInline || source === VariantSource.FallbackConfig || source === VariantSource.SecondaryInitialVariants;
};
//# sourceMappingURL=source.js.map